import axios from "axios";
import { API } from "../utils/constants";

let suppressSessionExpiryPopupUntil = 0;

/** While true, App axios interceptor should not open the “signed out” modal (intentional logout / race with validate-session). */
export function shouldSuppressSessionExpiryPopup() {
  return Date.now() < suppressSessionExpiryPopupUntil;
}

/**
 * Deletes the server Session row (same store used by verify middleware).
 * Call this before clearing client auth so other apps using the same token
 * (e.g. EduTri) see a failed session on their next validate call.
 */
export async function revokeServerSession(accessToken) {
  const token =
    typeof accessToken === "string"
      ? accessToken
      : accessToken?.token;
  if (!token) return;

  suppressSessionExpiryPopupUntil = Date.now() + 5000;

  try {
    await axios.post(
      `${API}/auth/logout`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
  } catch {
    // Token may already be invalid; client logout still proceeds.
  }
}
